var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1594_17826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1777 10.3989V15.9689C12.1777 16.3385 11.8824 16.6392 11.5195 16.6392H8.67773V16.0587H11.5195C11.5681 16.0587 11.6077 16.0184 11.6077 15.9689V10.3989H12.1777Z",
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1777 2.03108V7.61328H11.6077V2.03108C11.6077 1.98157 11.5681 1.94131 11.5195 1.94131H8.67773V1.36084H11.5195C11.8824 1.36084 12.1777 1.66153 12.1777 2.03108Z",
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59732 0.508983C8.54436 0.389106 8.46818 0.286102 8.37093 0.202783C8.27422 0.11985 8.16225 0.0612897 8.03815 0.028646C7.91339 -0.00410808 7.78268 -0.00879511 7.64959 0.0146952L0.736446 1.23498C0.529335 1.27153 0.339227 1.39726 0.201154 1.58898C0.0714191 1.76908 0 1.99102 0 2.21412V15.7859C0 16.0089 0.0714191 16.2309 0.201154 16.411C0.339227 16.6027 0.529281 16.7284 0.736446 16.765L7.64959 17.9853C7.70509 17.9951 7.76016 18 7.81457 18C7.89065 18 7.96543 17.9904 8.03815 17.9714C8.16225 17.9387 8.27422 17.8801 8.37093 17.7972C8.46818 17.7139 8.54436 17.6109 8.59732 17.491C8.6506 17.3705 8.67762 17.2389 8.67762 17.1V0.899992C8.67762 0.761035 8.6506 0.629468 8.59732 0.508928V0.508983ZM7.00763 9.86489C6.76522 9.86489 6.56872 9.47769 6.56872 9C6.56872 8.52231 6.76522 8.13511 7.00763 8.13511C7.25004 8.13511 7.44654 8.52231 7.44654 9C7.44654 9.47769 7.25004 9.86489 7.00763 9.86489Z",
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76172 9.91007V8.10198H13.1226V7.30811L15.9999 8.9999L13.1226 10.6917V9.91007H9.76172Z",
    fill: "white",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1226 10.6917V9.91007H9.76172V8.10198H13.1226V7.30811L15.9999 8.9999L13.1226 10.6917Z",
    fill: "white",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1594_17826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout2);
export default __webpack_public_path__ + "static/media/logout_2.a1a6288a.svg";
export { ForwardRef as ReactComponent };